"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _conferenceService;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaDeviceService = void 0;
const Service_1 = require("../Service");
const VoxeetRTC_1 = __importDefault(require("../../lib/adapter/VoxeetRTC"));
const Exceptions_1 = require("../../lib/Exceptions");
/**
 * MediaDeviceService allows the application to manage devices that are used during conferences. The service allows the application to:
 *
 * - Enumerate [audio](#enumerateaudiodevices) and [video](#enumeratevideodevices) devices.
 * - Select [audio](#selectaudioinput) and [video](#selectvideoinput) input devices.
 * - Select [output](#selectaudiooutput) devices.
 * - [Check](#getcomfortnoiselevel) the selected comfort noise level for output devices in Dolby Voice conferences and [change](#setcomfortnoiselevel) the comfort noise level. These functions are only available for the [Desktop SDK](doc:desktop-sdk) users.
 *
 * @noInheritDoc
 */
class MediaDeviceService extends Service_1.BaseConferenceService {
    /**
     * @ignore
     * @param sdk
     * @param conferenceService
     */
    constructor(sdk, conferenceService) {
        super(sdk);
        _conferenceService.set(this, void 0);
        __classPrivateFieldSet(this, _conferenceService, conferenceService);
    }
    /**
     * Enumerates audio devices.
     * @param type - The device type, either input or output.
     */
    enumerateAudioDevices(type = 'input') {
        /* if (this.conference && this.conference.rtc.enumerateAudioDevices) {
          return this.conference.rtc.enumerateAudioDevices(type);
        } else {*/
        return VoxeetRTC_1.default.enumerateAudioDevices(type);
        //}
    }
    /**
     * Enumerates video devices.
     * @param type - The device type, either input or output.
     */
    enumerateVideoDevices(type = 'input') {
        return VoxeetRTC_1.default.enumerateVideoDevices();
    }
    /**
     * Enables the selection of an audio device input.
     * @param deviceId - The device ID.
     */
    selectAudioInput(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (deviceId) {
                return __classPrivateFieldGet(this, _conferenceService).manager.selectAudioInput(deviceId);
            }
        });
    }
    /**
     * Enables the selection of an audio device output.
     * @param deviceId - The device ID.
     */
    selectAudioOutput(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _conferenceService).manager.isDvwc()) {
                throw new Exceptions_1.UnsupportedError();
            }
            if (deviceId) {
                return __classPrivateFieldGet(this, _conferenceService).manager.rtc.selectAudioOutput(deviceId);
            }
        });
    }
    /**
     * Enables the selection of a video device input.
     * @param deviceId - The device ID.
     * @param constraints - The [MediaTrackConstraints](https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints#Properties_of_video_tracks).
     */
    selectVideoInput(deviceId, constraints) {
        return __awaiter(this, void 0, void 0, function* () {
            if (deviceId) {
                return __classPrivateFieldGet(this, _conferenceService).manager.selectVideoInput(deviceId, constraints);
            }
        });
    }
    /**
     * Configures the comfort noise level for output devices in Dolby Voice conferences. This API is only available for the [Desktop SDK](doc:desktop-sdk) users.
     *
     * @param level - The selected comfort noise level.
     */
    setComfortNoiseLevel(level) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _conferenceService).manager.isElectron()) {
                throw new Exceptions_1.UnsupportedError();
            }
            return __classPrivateFieldGet(this, _conferenceService).manager.rtc.setComfortNoiseLevel(level);
        });
    }
    /**
     * Retrieves the comfort noise level setting for output devices in Dolby Voice conferences. This API is only available for the [Desktop SDK](doc:desktop-sdk) users.
     *
     * @return The comfort noise level.
     */
    getComfortNoiseLevel() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _conferenceService).manager.isElectron()) {
                throw new Exceptions_1.UnsupportedError();
            }
            return __classPrivateFieldGet(this, _conferenceService).manager.rtc.getComfortNoiseLevel();
        });
    }
}
_conferenceService = new WeakMap();
__decorate([
    Service_1.ConferenceNotNull()
], MediaDeviceService.prototype, "selectAudioInput", null);
__decorate([
    Service_1.ConferenceNotNull()
], MediaDeviceService.prototype, "selectAudioOutput", null);
__decorate([
    Service_1.ConferenceNotNull()
], MediaDeviceService.prototype, "selectVideoInput", null);
__decorate([
    Service_1.ConferenceNotNull()
], MediaDeviceService.prototype, "setComfortNoiseLevel", null);
__decorate([
    Service_1.ConferenceNotNull()
], MediaDeviceService.prototype, "getComfortNoiseLevel", null);
exports.MediaDeviceService = MediaDeviceService;
